import { render, staticRenderFns } from "./GeofenceForm.vue?vue&type=template&id=546b1564&"
import script from "./GeofenceForm.vue?vue&type=script&lang=js&"
export * from "./GeofenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports